<template lang="pug">
  .searching.container.mx-auto(v-if="(products && products.loading) || loading")
    Spinner(:size="10" :thickness="2")
  .found.container.mx-auto(v-else-if="query" ref="container")
    template(v-if="product")
      PreorderProduct(:product="product")
    template(v-else-if="products && products.items && products.items.length")
      .alert
        p Hier die Produkte zu Ihrer Suche nach "<b>{{ query }}</b>"
      .teasers(v-if="teasers && teasers.length" ref="teasers")
        .top-row.flex(v-if="(teasers && teasers.length) || showFilters")
          .filters.flex-grow
        .justified.paginated-teasers(v-if="activeOrientation === 'justified'" :style="{ height: `${layoutGeometry.containerHeight}px` }")
          Teaser(
            v-for="teaser in cards"
            :key="teaser.id"
            v-if="teaser"
            :teaser="teaser"
            display="card"
          )
        .horizontal.paginated-teasers(v-else-if="activeOrientation === 'horizontal'")
          Teaser(
            v-for="teaser in teasers"
            :key="teaser.id"
            v-if="teaser"
            :teaser="teaser"
            display="card"
          )
        .vertical.paginated-teasers(v-else-if="activeOrientation === 'vertical'")
          Teaser(
            v-for="teaser in teasers"
            :key="teaser.id"
            v-if="teaser"
            :teaser="teaser"
            display="row"
          )
      Pagination(
        v-if="pageInfo && pageInfo.lastPage > 1"
        :last-page="pageInfo.lastPage"
        :current-page="pageInfo.currentPage"
        nav-class="pagination is-rounded is-centered"
        @change="changePage"
      )
        template(v-slot:prev)
          span.icon
            svg.svg-inline--fa(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512')
              path(d='M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z')
        template(v-slot:next)
          span.icon
            svg.svg-inline--fa(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512')
              path(d='M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z')
          
    .alert.warning(v-else)
      p Zu der Suche nach "<b>{{ query }}</b>" konnten keine Produkte gefunden werden
</template>

<script>
import { mapActions } from 'vuex';
import { get, cloneDeep } from '@/helpers';

import CategoryProducts from '@/extensions/shop/components/CategoryProducts';

export default {
    name: 'ProductSearchResults',
    extends: CategoryProducts,
    data: () => ({
        product: undefined
    }),
    watch: {
        '$route.query'(query) {
            window.scrollTo(0, 0);
            this.currentPage = get(query, `P${this.section.id}`) || 1;
            this.refetch(this.query);
        }
    },
    computed: {
        query() {
            return get(this.$route, 'query.s');
        },
        addToCart() {
            return !!get(this.$route, 'query.add-to-cart');
        }
    },
    methods: {
        async refetch(query) {
            if (!query) return false;
            this.loading = true;
            this.product = undefined;

            const shop = get(this.cms, 'shop.id');

            if (this.addToCart) {
                const articles = await this.fetchArticles({
                    skip: 0,
                    take: 1,
                    skus: [this.query],
                    shop: parseInt(shop)
                });
                if (articles.length === 1) {
                    const article = articles[0];
                    const selectableProductProperties = article.product.propertyPivots.filter(el => {
                        return el.values.length > 1 && el.property.article_required === false;
                    });

                    if (
                        !selectableProductProperties.length &&
                        (article.product.manage_stock !== true || article.qty_sum)
                    ) {
                        let productPropertyValues = [];
                        this.addArticleToCart({ article, productPropertyValues, qty: parseInt(this.qty) });

                        this.product = await this.fetchProduct({ id: parseInt(article.product.id) });
                        this.products.loading = false;
                        this.loading = false;
                        return false;
                    }
                }
            }

            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: 15
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'query',
                        like: this.query
                    },
                    {
                        key: 'qty_sum',
                        from: 1
                    }
                ],
                order: 'nr',
                direction: 'asc'
            };

            this.fetchProducts(payload).then(response => {
                if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                    this.changePage(response.pageInfo.lastPage);
                    return;
                }

                const products = cloneDeep(response);
                const container = document.querySelector('.preorder-columns > .column.left > .ps');
                if (container) container.scrollTop = 0;

                if (products.items && products.items.length) {
                    products.items.forEach((product, i) => {
                        product.position = i + 1;
                    });
                }

                this.products = products;
                // this.insertProducts({ products });
                this.loading = false;
            });
        },
        ...mapActions({
            fetchProduct: 'shop/fetchProduct',
            fetchArticles: 'shop/fetchArticles',
            addArticleToCart: 'shop/addArticleToCart'
        })
    },
    mounted() {
        this.$nextTick(() => {
            if (this.query) {
                this.refetch(this.query);
            } else {
                this.products.loading = false;
            }
        });
    }
};
</script>

<style lang="sass" scoped>
.searching
  min-height: 4rem

.alert
  margin-bottom: 2rem

.products ::v-deep .arrow-container
  display: none

.found
  display: flex
  flex-direction: column
  flex-grow: 1
  .teasers
    width: 100%
  .pagination-container
    margin-top: 1rem
    max-width: 100%
  .paginated-teasers
    &.horizontal
      // align-content: space-around
      // justify-content: space-between
      @screen sm
        @apply grid
        gap: 1rem
        grid-template-columns: 1fr
        grid-template-columns: repeat(2, 292px)
        ::v-deep
          figure
            width: 292px
            height: 424px
      @screen md
        grid-template-columns: repeat(2, 356px)
        ::v-deep
          figure
            width: 360px
            height: 500px
      @screen lg
        grid-template-columns: repeat(3, 318px)
        ::v-deep
          figure
            width: 318px
            height: 456px
      @screen xl
        grid-template-columns: repeat(3, 320px)
        ::v-deep
          figure
            width: 320px
            height: 320px
      @screen 2xl
        grid-template-columns: repeat(4, 273px)
        ::v-deep
          figure
            width: 273px
            height: 396px
      // @screen md
      //   @apply flex flex-wrap
      //   // justify-between
      //   ::v-deep .product-teaser
      //     width: 300px
      .product-teaser-link
        display: block
        & + .product-teaser-link
          margin-top: 1rem
          @screen sm
            margin-top: 0

    &.vertical
      // TODO
    &.justified
      position: relative
</style>
